var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _vm.isLimitAct()
      ? _c("div", { staticClass: "app_empty" }, [
          _vm._v("\n    活动已过期\n  ")
        ])
      : _c(
          "div",
          [
            (_vm.isApp || _vm.passApp) && !_vm.paramError
              ? _c("router-view")
              : !_vm.isApp && !_vm.passApp
              ? _c("div", { staticClass: "app_empty" }, [
                  _vm._v("\n      请在APP中打开此网址\n    ")
                ])
              : _vm.paramError
              ? _c("div", { staticClass: "app_empty" }, [
                  _vm._v(
                    "\n      参数获取异常，请联系管理员：" +
                      _vm._s(_vm.paramErrCode) +
                      "\n    "
                  )
                ])
              : _vm._e()
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/vue-loader@13.7.3_babel-cor_0eb103b55073f995f96d18576d800012/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.pnpm/vue-loader@13.7.3_babel-cor_0eb103b55073f995f96d18576d800012/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 